import { Pipe, PipeTransform } from '@angular/core';
import { map, tap } from 'rxjs/operators';
import { ChoiceListService } from '../choice-list/choice-list.service';

@Pipe({ name: 'asyncChoiceListChoices' })
export class asyncChoiceListChoicesPipe implements PipeTransform {
    constructor(private choiceListService: ChoiceListService) {}

    transform(
        input: any,
        objectStore: string,
        choiceListName: string,
        gerritService: string = null
    ) {
        return this.choiceListService
            .getByID(objectStore, choiceListName, gerritService)
            .pipe(
                map(v =>
                    Object.keys(v.value).reduce(
                        (acc, row) => [
                            ...acc,
                            {
                                id: Number(row) ? Number(row) : row,
                                value: v.value[row],
                            },
                        ],
                        []
                    )
                ),
                map(v => v.sort((a, b) => (a.value > b.value ? 1 : -1)))
            );
    }
}
